module.exports = __webpack_public_path__ + "static/media/diff.fff96eaf.png";